import { mapState } from "vuex";
import { getMenuTree } from "@/api/menuList";
import { uuidv4, bubbleSort, imgType } from "@/utils";
export default {
  data() {
    return {
      // 按钮对应结构数据（key为数字，不可采用obj.key来获取、但是大大方便了代码已有的传值逻辑）
      buttonConfig: {
        // 新增
        1: {
          iconName: "el-icon-circle-plus-outline",
          name: "新增数据",
          flag: 1,
        },
        // 编辑
        2: {
          iconName: "el-icon-edit-outline",
          name: "编辑数据",
          flag: 2,
        },
        // 查看
        3: {
          iconName: "el-icon-view",
          name: "查看详情",
          flag: 3,
        },
        // 删除
        4: {
          iconName: "el-icon-delete",
          name: "删除数据",
          flag: 4,
        },
        // 导入
        5: {
          iconName: "el-icon-upload2",
          name: "导入Excel",
          flag: 5,
        },
        // 导出
        6: {
          iconName: "el-icon-download",
          name: "导出Excel",
          flag: 6,
        },
        // 回收站
        7: {
          iconName: "el-icon-delete",
          name: "回收站",
          flag: 7,
        },
      },
      // 表单字段配置信息
      fieldConfig: {
        cnName: "",
        enName: "",
        isAssociate: false, // 是否是关联字段
        // 关联配置
        assConfig: {
          type: 1, // 1-自定义、2-定制化
          tableId: "", // 关联表格Id
          fieldEnName: "", // 关联表格字段enName
          cusName: "user", // user-用户、depart-部门、project-项目、agreement-合同
          assStr: "", // 关联关系回显字段
        },
        rules: {
          type: "text", // 字段类型text、select、date、rich、file
          // 基本配置
          baseConfig: {
            title: "", // 字段分类标题
            width: "200", // 字段宽度
            align: "center", // 字段对齐方式 center、left、right
            color: "#606266", // 表格字段颜色
            isOnly: false, // 是否为唯一字段（多条数据数值不重复）
            isFixed: false, // 是否固定 （最多为3列）
            isList: true, // 列表展示、详情展示，后端为isShow
            isRequire: true, // 是否必选
          },
          // 其他配置
          otherConfig: {
            isTip: false, // 是否有提示
            tipColor: "#333", // 提示颜色
            tipValue: "", // 字段提示，没有可以不填写
            compareValue: "", // 字段对比值、没有可以不填写
          },
          // 文本类型配置
          textConfig: {
            type: "text", // 输入框类型,3种text、number、textarea
            limit: "", // 备用字段
            isListEdit: false, //  是否支持列表页直接编辑
          },
          // 时间类型配置
          dateConfig: {
            type: "date", // 时间年月日date、时间是分秒time、两者datetime
            isRange: false, // 是否为时间范围
          },
          // 选择类型配置
          selectConfig: {
            type: "radio", // 选择类型单选radio、多选multi、下拉单选radioSelect、下拉多选multiSelect
            value: "", // 选项值以/分割
          },
          // 富文本类型配置
          richConfig: {
            customToolbar: [
              "bold",
              "italic",
              "underline",
              "image",
              "video",
              "code",
            ], // 富文本初始化配置 按照顺序加粗、斜体、下划线、图片、视频、代码
          },
          // 文本类型配置
          fileConfig: {
            type: "all", // 全部all、图片img、其余文件file
            min: 1, // 最少上传个数
            limit: 1, // 最多上传个数
            size: 2, // 最大上传大小
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      $messageCount: (state) => state.utils.messageCount,
      $todoCount: (state) => state.utils.todoCount,
      $collapse: (state) => state.utils.collapse,
      $userInfo: (state) => state.utils.userInfo,
      $breadList: (state) => state.utils.breadList,
      $routerList: (state) => state.utils.routerList,
      $subRouterList: (state) => state.utils.subRouterList,
      $buttonList: (state) => state.utils.buttonList,
      $findType: (state) => state.utils.findType,
      $theme: (state) => state.utils.theme,
      $showAllTask: (state) => state.utils.showAllTask,
      $configList: (state) => state.utils.configList,
      $fileReady: (state) => state.utils.fileReady,
    }),
  },
  methods: {
    $exportExcel: function (data, name, type = "xls") {
      let blob = new Blob([data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = `${name}.${type}`; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // 检测所有文件是否上传成功
    $checkFileSuccess() {
      let count = 1;
      for (let i in this.$fileReady) {
        if (this.$fileReady[i] == "ready") {
          count = 0;
          break;
        }
      }
      return count == 1;
    },
    // 条件判断，模块栏目
    $chargeConditionList(list, conditionArr, formData) {
      let flag = 0;
      list.map((res) => {
        // 有一个展示则显示模块
        if (this.$chargeCondition(res, conditionArr, formData)) {
          flag = 1;
        }
      });
      if (flag == 1) {
        return true;
      } else {
        return false;
      }
    },
    // 条件判断 单个填报栏目
    $chargeCondition(value, conditionArr, formData) {
      let countflag = 0;
      let item = conditionArr[value.enName];
      if (item instanceof Array) {
        item.map((res) => {
          if (this.$conditionField(res, value, formData, "noset")) {
            countflag = 1;
          }
        });
        if (countflag == 1) {
          return true;
        } else {
          this.$conditionResetForm(formData, value);
          return false;
        }
      } else if (item) {
        return this.$conditionField(item, value, formData);
      } else {
        return true;
      }
    },
    // 条件判断 针对每一个字段对象
    $conditionField(item, value, formData, type) {
      let flag = 0;
      item.list.map((res) => {
        // 判断条件
        switch (res.ruleType) {
          case 1:
            if (formData[res.enName] == res.value) {
              flag += 1;
            }
            break;
          case 2:
            if (formData[res.enName].indexOf(res.value) > -1) {
              flag += 1;
            }
            break;
          case 3:
            if (parseFloat(formData[res.enName]) > parseFloat(res.value)) {
              flag += 1;
            }
            break;
          case 4:
            if (parseFloat(formData[res.enName]) < parseFloat(res.value)) {
              flag += 1;
            }
            break;
          case 5:
            if (formData[res.enName] != res.value) {
              flag += 1;
            }
            break;
          default:
            if (formData[res.enName] == res.value) {
              flag += 1;
            }
            break;
        }
      });
      // 且或匹配
      if (item.ruleSp == "and") {
        if (flag !== item.list.length && !type) {
          this.$conditionResetForm(formData, value);
        }
        return flag == item.list.length;
      } else {
        if (flag == 0 && !type) {
          this.$conditionResetForm(formData, value);
        }
        return flag > 0;
      }
    },
    // 条件重置数据类型
    $conditionResetForm(formData, value) {
      formData[value.enName] =
        value.dataType == "array" ? [] : value.dataType == "number" ? 0 : "";
    },
    // 判断是否是图片
    $chargeImg(name, type) {
      if (type) {
        return type == 2;
      } else {
        let type = name
          ? name.substring(name.lastIndexOf(".") + 1).toLowerCase()
          : "";
        return imgType.includes(type);
      }
    },

    // 兼容所有文件地址
    $operateUrl(url) {
      let newUrl = "";
      if (
        url &&
        process.env.VUE_APP_OLDURL &&
        url.indexOf(process.env.VUE_APP_FILEURL) < 0
      ) {
        newUrl = url.replace(
          process.env.VUE_APP_OLDURL,
          process.env.VUE_APP_FILEURL
        );
      } else {
        newUrl = url;
      }
      return newUrl;
    },
    sortFun(data, key, type) {
      let newData = this.$deepClone(data);
      return bubbleSort(newData, key, type);
    },

    /**
     *  模版转换【】中的内容
     * @param {*原文字} str
     * @param {*中英文对象} field
     * @param {*数据项} target
     */
    $changeContent(str, field, data) {
      let newStr = str;
      let reg = /【(.*?)】/gi;
      let tmp = str.match(reg);
      if (tmp) {
        for (var i = 0; i < tmp.length; i++) {
          let cnName = tmp[i].replace(reg, "$1");
          let value = data && data[field[cnName]] ? data[field[cnName]] : "";
          newStr = newStr.replace(tmp[i], value);
        }
      }
      return newStr;
    },
    /**
     * 添加模版字段
     * @taget 对象
     * @name  key、value格式中的key
     * @id    dom元素
     * @value 传值参数
     * @type  是否要加【】
     *  */
    $addTemp(value, id, target, name, type) {
      let val = type ? value : "【" + value + "】";
      let elInput = document.getElementById(id);
      let startPos = elInput.selectionStart;
      let endPos = elInput.selectionEnd;
      // 判断是否有光标, 有光标在光标后面新增, 没有光标直接在最后拼接
      if (startPos === undefined || endPos === undefined) {
        let txt = elInput.value;
        let result = txt + val;
        target[name] = result;
      } else {
        let txt = elInput.value;
        let result = txt.substring(0, startPos) + val + txt.substring(endPos);
        elInput.value = result;
        elInput.focus();
        this.$nextTick(() => {
          elInput.selectionStart = startPos + val.length;
          elInput.selectionEnd = startPos + val.length;
        });
        target[name] = result;
      }
    },
    // 设置列表动效uuid
    $setId(data) {
      let newData = this.$deepClone(data);
      newData.uuid = uuidv4();
      return newData;
    },
    // 获取菜单列表(所有菜单、最多100条)
    $getMenuList() {
      return getMenuTree().then((res) => {
        if (res) {
          return res.data;
        } else {
          return false;
        }
      });
    },
    // 根据菜单id获取菜单名
    $getMenuName(id, data) {
      let arr = [];
      arr = data.filter((res) => {
        return res.id == id;
      });
      if (arr.length > 0) {
        return arr[0].menuName;
      } else {
        return "";
      }
    },
    // 文件统一导出
    $exportFile(name, data) {
      const blob = new Blob([data]);
      const elink = document.createElement("a");
      elink.download = name;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    // 文件统一下载
    $downLoadFn(fileName, url) {
      this.urlToBlob(url, (res) => {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(res);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      });
    },
    // 文件下载用方法
    urlToBlob(the_url, callback) {
      let xhr = new XMLHttpRequest();
      xhr.open("get", the_url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          if (callback) {
            callback(this.response);
          }
        }
      };
      xhr.send();
    },
    // base64转图片文件
    $dataURLtoFile(dataurl, filename) {
      // 获取到base64编码
      const arr = dataurl.split(",");
      // 将base64编码转为字符串
      const bstr = window.atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n); // 创建初始化为0的，包含length个元素的无符号整型数组
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: "image/png",
      });
    },

    // 过滤出有指定叶子节点的树
    $filterTreeByLeafType(treeData, type) {
      function hasLeafOfType(node) {
        if (!node.children || node.children.length === 0) {
          // 叶子节点，检查其类型是否匹配
          return node.type === type;
        } else {
          // 非叶子节点，递归检查子节点
          const filteredChildren = node.children.filter((child) =>
            hasLeafOfType(child)
          );
          node.children = filteredChildren; // 更新子节点
          return filteredChildren.length > 0; // 返回是否有符合条件的子节点
        }
      }

      const filteredTree = treeData.filter((node) => hasLeafOfType(node));
      return filteredTree;
    },
  },
};
